export const environment = {
  production: false,
  apiUrl: 'https://text-mining-api.cpit.dev',
  keycloakConfig: {
    url: 'https://auth.cpit.dev',
    realm: 'cpit-dev',
    clientId: 'text-mining-frontend',
  },
};
